import "./base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Models ??= {};

AssessmentBuilder.Models.Question = class Question extends AssessmentBuilder.Models.Base {
  defaults() {
    return {
      id: this.constructor.guid(),
      title: "Untitled Question",
      instructions: null,
      required: false,
      responseType: "select_one",
      position: 0,
      shuffleResponses: false,
      responses: new AssessmentBuilder.Collections.Responses(),
      image: null, // ThumbnailEditor JSON that controls the image for this question
      allowExplanation: false,
    };
  }
};

AssessmentBuilder.Models.Question.prototype.relations = [
  {
    type: Backbone.HasMany,
    key: "responses",
    relatedModel: "AssessmentBuilder.Models.Response",
    collectionType: "AssessmentBuilder.Collections.Responses",
    reverseRelation: {
      key: "question",
      includeInJSON: false,
    },
  },
];

AssessmentBuilder.Models.Question.initializeRelations();
